import { MobileLineBreak } from "@components/LineBreak";

import CarModel from "./carModel";
import "./style.scss";

const TechIntroSection_2 = () => {
	return (
		<section className="tech-intro-section_2">
			<div className="tech-intro-section_2__content">
				<div className="tech-intro-section_2__title-wrapper">
					<h2 className="title">
						단순한 필름이 아닌,
						<MobileLineBreak />
						시야의 기술
					</h2>
					<p className="sub-title">뷰아드는 선명한 VIEW 강력한 GUARD 입니다</p>
				</div>
				<CarModel />
			</div>
		</section>
	);
};

export default TechIntroSection_2;
